import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ahp9syqhb: FaireBrandEntity = {
  token: "b_7ahp9syqhb",
  type: "brand",
  name: "Magic Sleek",
  avatarUrl:
    "https://cdn.faire.com/fastly/653d2ad2163850610c37ebe64ddc6c43de59ee3912f5cf24c3e5de17f27ff4a8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ae4e768880c62ea1dd5bb9c3af44177f3eaf49591bc537d8b04c15a0f3a339be.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/653d2ad2163850610c37ebe64ddc6c43de59ee3912f5cf24c3e5de17f27ff4a8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ae4e768880c62ea1dd5bb9c3af44177f3eaf49591bc537d8b04c15a0f3a339be.jpeg",
  location: "Manalapan, NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "An innovative hair straightening system that has wash & wear results. A formaldehyde-free product that restores the health of your hair, eliminates frizz and redefines curls. Maintenance products ensure the longevity of the Magic Sleek treatment for up to 6 months. Magic Sleek the only one brand on the market compliant with FDA, OSHA and European Union regulation.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:47.585Z",
    importedBy: "entity-db-cli",
  },
};
